import Link from "next/link";
import { useRouter } from "next/router";
import { useHr } from "@/hooks/useHr";

const HRWishlist = ({ userId }) => {
  const router = useRouter();
  const { wishlistCount } = useHr(userId, 'hr');

  const handleWishlistClick = (e) => {
    e.preventDefault();
    router.push("/hr-admin/shortlisted-candidates");
  };

  return (
    <li className="access-icon">
      <Link
        className="rbt-round-btn"
        href="/hr-admin/wishlist"
        onClick={handleWishlistClick}
        title="Wishlist"
      >
        <i className="feather-heart"></i>
        {wishlistCount > 0 && (
          <span className="rbt-notification-count">
            {wishlistCount > 99 ? "99+" : wishlistCount}
          </span>
        )}
      </Link>
    </li>
  );
};

export default HRWishlist;